import "./Events.css";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { GetEvents } from "../../apis/api/EventsApi";
import { useDispatch, useSelector } from "react-redux";

const fadeUp  = { hidden:{opacity:0,y:24}, show:{opacity:1,y:0} };
const stagger = { show:{ transition:{ staggerChildren:.12 } } };

const EventsMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => { dispatch(GetEvents()); }, []);

  const { events } = useSelector((s) => s.EventSlice);

  // Determine status by end_date — ignore DB status
  const now = Date.now() / 1000; // current unix timestamp
  const currentEvents = (events || []).filter(e => Number(e.end_date) >= now);
  const pastEvents    = (events || []).filter(e => Number(e.end_date) <  now);
  const totalEvents   = (events || []).length;

  const go = (list, key) =>
    navigate("/EventsCards", { state: { Event: list, from: location.pathname, categoryKey: key } });

  const cards = [
    {
      key:      "current",
      label:    "Current Events",
      desc:     "Explore live and upcoming events happening right now. Connect with members and expand your network.",
      list:     currentEvents,
      img:      `${process.env.PUBLIC_URL}/Event-Management-Tips-5.jpg`,
      badge:    "current",
      badgeTxt: "Live Now",
      icon:     "bx bx-radio-circle-marked",
    },
    {
      key:     "past",
      label:   "Past Events",
      desc:    "Browse events that have already taken place. Revisit highlights and key moments from the community.",
      list:    pastEvents,
      img:     `${process.env.PUBLIC_URL}/Meeting-and-Conferences-4-480x320.jpeg`,
      badge:   "past",
      badgeTxt:"Archived",
      icon:    "bx bx-history",
    },
  ];

  const stats = [
    { icon:"bx bx-calendar-event", label:"Total Events",   val: totalEvents },
    { icon:"bx bx-radio-circle-marked", label:"Live Now",  val: currentEvents.length },
    { icon:"bx bx-history",        label:"Past Events",    val: pastEvents.length },
  ];

  return (
    <motion.div className="em-wrap"
      variants={stagger} initial="hidden" animate="show">

      {/* header */}
      <motion.div className="em-header" variants={fadeUp}>
        <h1 className="em-title">Events</h1>
        <p className="em-sub">Browse current and past events from your network.</p>
      </motion.div>

      {/* stats strip */}
      <motion.div className="em-stats" variants={fadeUp}
        transition={{ duration:.4, delay:.05 }}>
        {stats.map((s) => (
          <div key={s.label} className="em-stat-card">
            <span className="em-stat-icon"><i className={s.icon}></i></span>
            <div>
              <p className="em-stat-val">{s.val}</p>
              <p className="em-stat-label">{s.label}</p>
            </div>
          </div>
        ))}
      </motion.div>

      {/* main cards */}
      <div className="em-grid">
        {cards.map((c, i) => (
          <motion.div key={c.key} className="em-card"
            variants={fadeUp}
            transition={{ duration:.5, delay: i * .1, ease:[.22,.68,0,1.2] }}
            whileHover={{ y:-6, boxShadow:"0 28px 60px rgba(15,23,42,.20)" }}
            whileTap={{ scale:.98 }}
            onClick={() => go(c.list, c.key)}>

            <motion.img src={c.img} className="em-card-img" alt={c.label}
              whileHover={{ scale:1.06 }} transition={{ duration:.5 }}
              onError={(e) => { e.target.style.display="none"; }} />

            <div className="em-card-overlay" />

            <span className="em-card-arrow">
              <i className="bx bx-right-arrow-alt"></i>
            </span>

            <div className="em-card-body">
              <span className={`em-card-badge ${c.badge}`}>
                <i className={c.icon}></i> {c.badgeTxt}
              </span>
              <h2 className="em-card-title">{c.label}</h2>
              <p className="em-card-desc">{c.desc}</p>
              <div className="em-card-footer">
                <span className="em-card-count">
                  <i className="bx bx-calendar-event"></i>
                  {c.list.length} Event{c.list.length !== 1 ? "s" : ""}
                </span>
                <button className="em-card-cta">
                  Browse <i className="bx bx-right-arrow-alt"></i>
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

    </motion.div>
  );
};

export default EventsMenu;
